// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3cz70","notes":"Notes_notes__KF9xi"};